import * as React from 'react'

const SvgLanguageIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3781_92252)">
      <path
        d="M7.64493 10.4711C7.61286 10.3105 6.5081 4.78668 6.47306 4.61164C6.41833 4.33777 6.17782 4.14062 5.89853 4.14062H4.72665C4.44735 4.14062 4.20685 4.33777 4.15212 4.61164C4.11653 4.78965 3.01064 10.3191 2.98024 10.471C2.91677 10.7884 3.12259 11.097 3.43989 11.1605C3.7572 11.2239 4.06591 11.0181 4.12935 10.7008L4.50388 8.82812H6.1213L6.49583 10.7009C6.55931 11.0183 6.86813 11.224 7.18528 11.1605C7.50259 11.097 7.70841 10.7884 7.64493 10.4711ZM4.73825 7.65625L5.207 5.3125H5.41817L5.88692 7.65625H4.73825Z"
        fill="white"
      />
      <path
        d="M17.0312 8.82812H15.2734V8.24219C15.2734 7.91859 15.0111 7.65625 14.6875 7.65625C14.3639 7.65625 14.1016 7.91859 14.1016 8.24219V8.82812H12.3438C12.0202 8.82812 11.7578 9.09047 11.7578 9.41406C11.7578 9.73766 12.0202 10 12.3438 10H12.4855C12.8194 11.0786 13.3221 11.9065 13.8752 12.5699C13.425 12.9817 12.9695 13.3194 12.5637 13.644C12.311 13.8462 12.27 14.2149 12.4722 14.4676C12.6745 14.7204 13.0432 14.7611 13.2957 14.5591C13.7038 14.2326 14.1929 13.8698 14.6875 13.4159C15.1825 13.8702 15.6725 14.2336 16.0793 14.5591C16.332 14.7613 16.7007 14.7202 16.9028 14.4676C17.105 14.2149 17.064 13.8461 16.8113 13.644C16.4066 13.3202 15.9505 12.9821 15.4998 12.5699C16.0529 11.9065 16.5556 11.0786 16.8895 10H17.0312C17.3548 10 17.6172 9.73766 17.6172 9.41406C17.6172 9.09047 17.3548 8.82812 17.0312 8.82812ZM14.6875 11.7088C14.3135 11.2393 13.977 10.6788 13.7233 9.99609H15.6516C15.398 10.6788 15.0615 11.2393 14.6875 11.7088Z"
        fill="white"
      />
      <path
        d="M18.2422 3.55469H9.78902L9.53785 1.53977C9.42813 0.661953 8.67828 0 7.79363 0H1.75781C0.788555 0 0 0.788555 0 1.75781V14.6875C0 15.6568 0.788555 16.4453 1.75781 16.4453H6.69855L6.94652 18.4602C7.05605 19.3363 7.8059 20 8.69078 20H18.2422C19.2114 20 20 19.2114 20 18.2422V5.3125C20 4.34324 19.2114 3.55469 18.2422 3.55469ZM1.75781 15.2734C1.43473 15.2734 1.17188 15.0106 1.17188 14.6875V1.75781C1.17188 1.43473 1.43473 1.17188 1.75781 1.17188H7.79363C8.08852 1.17188 8.33848 1.3925 8.375 1.68492C8.45992 2.36602 9.98469 14.5978 10.0689 15.2734H1.75781ZM8.07516 18.0371L7.87926 16.4453H9.45129L8.07516 18.0371ZM18.8281 18.2422C18.8281 18.5653 18.5653 18.8281 18.2422 18.8281H8.94039L11.171 16.2479C11.2852 16.1191 11.3364 15.9482 11.3128 15.7782L9.93512 4.72656H18.2422C18.5653 4.72656 18.8281 4.98941 18.8281 5.3125V18.2422Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3781_92252">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgLanguageIcon
